import { ApolloQueryResult } from 'apollo-client';
import { getContentfulClient } from 'graphql/clients';
import { MiniArticleCard } from 'data/global/types';
import { RelatedArticleQuery } from 'graphql/__generated__/operations/RelatedArticleQuery';
import { miniArticleCardTransformer } from 'data/global/transformer';
import gql from 'graphql-tag';
import { MiniArticleCardFragment } from 'data/global/fragments/MiniArticleCardFragment';

const RelatedArticlesQuery = gql`
  ${MiniArticleCardFragment}
  query RelatedArticleQuery($articleIds: [String!]!) {
    articleCollection(
      where: { sys: { id_in: $articleIds }, discoverable: true }
    ) {
      ...MiniArticleCardFragment
    }
  }
`;

/**
 * Get 5 related articles using the IDs returned from the getRelatedArticleIds query
 */
export const getRelatedArticles = async (
  articleIds: string[],
): Promise<MiniArticleCard[]> => {
  const ContentfulClient = getContentfulClient(false);

  const {
    data,
  }: ApolloQueryResult<RelatedArticleQuery> = await ContentfulClient.query({
    query: RelatedArticlesQuery,
    variables: { articleIds },
    errorPolicy: 'none',
  });

  const relatedArticles = data.articleCollection?.items ?? [];

  return relatedArticles.map((article) => {
    if (!article?.title || !article?.slug) {
      throw Error('This related article is missing important data');
    }
    return miniArticleCardTransformer(article);
  });
};
